import Cookies from 'js-cookie';
import { injectGTMCode } from './boot-inject-gtm-code';
import { getClientIpSource } from './utils-get-user-info';

export function initGTM() {
    window.dataLayer = window.dataLayer || [];

    // Setting the `AcronisInternal` cookie for store.acronis.com
    const userType = getClientIpSource();
    const isInternal = userType === 'internal';
    Cookies.set('AcronisInternal', isInternal.toString(), {
        path: '/',
        domain: '.acronis.com',
        expires: 30, // days
    });

    window.dataLayer.push({
        NewWebsite: 1,
        userType,
    });

    /* eslint-disable no-underscore-dangle */
    if (!window._gtm_init) {
        window._gtm_init = 1;
        injectGTMCode();
    }
    /* eslint-enable no-underscore-dangle */
}
